import { render, staticRenderFns } from "./AmlKyc.vue?vue&type=template&id=4ccdbe70"
import script from "./AmlKyc.vue?vue&type=script&lang=js"
export * from "./AmlKyc.vue?vue&type=script&lang=js"
import style0 from "./AmlKyc.vue?vue&type=style&index=0&id=4ccdbe70&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports